import React from 'react';

interface Props {
  className?: string;
}
export default function FilterIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2.5C10 2.22386 10.2239 2 10.5 2H11.5C11.7761 2 12 2.22386 12 2.5V3.5C12 3.77614 12.2239 4 12.5 4H21.5C21.7761 4 22 4.22386 22 4.5V5.5C22 5.77614 21.7761 6 21.5 6H12.5C12.2239 6 12 6.22386 12 6.5V7.5C12 7.77614 11.7761 8 11.5 8H10.5C10.2239 8 10 7.77614 10 7.5V2.5Z"
        fill="currentColor"
      />
      <path
        d="M2 4.5C2 4.22386 2.22386 4 2.5 4H7.5C7.77614 4 8 4.22386 8 4.5V5.5C8 5.77614 7.77614 6 7.5 6H2.5C2.22386 6 2 5.77614 2 5.5V4.5Z"
        fill="currentColor"
      />
      <path
        d="M8 18.5C8 18.2239 7.77614 18 7.5 18H2.5C2.22386 18 2 18.2239 2 18.5V19.5C2 19.7761 2.22386 20 2.5 20H7.5C7.77614 20 8 19.7761 8 19.5V18.5Z"
        fill="currentColor"
      />
      <path
        d="M20 10.5C20 10.7761 20.2239 11 20.5 11H21.5C21.7761 11 22 11.2239 22 11.5V12.5C22 12.7761 21.7761 13 21.5 13H20.5C20.2239 13 20 13.2239 20 13.5V14.5C20 14.7761 19.7761 15 19.5 15H18.5C18.2239 15 18 14.7761 18 14.5V9.5C18 9.22386 18.2239 9 18.5 9H19.5C19.7761 9 20 9.22386 20 9.5V10.5Z"
        fill="currentColor"
      />
      <path
        d="M22 18.5C22 18.2239 21.7761 18 21.5 18H12.5C12.2239 18 12 17.7761 12 17.5V16.5C12 16.2239 11.7761 16 11.5 16H10.5C10.2239 16 10 16.2239 10 16.5V21.5C10 21.7761 10.2239 22 10.5 22H11.5C11.7761 22 12 21.7761 12 21.5V20.5C12 20.2239 12.2239 20 12.5 20H21.5C21.7761 20 22 19.7761 22 19.5V18.5Z"
        fill="currentColor"
      />
      <path
        d="M2 11.5C2 11.2239 2.22386 11 2.5 11H15.5C15.7761 11 16 11.2239 16 11.5V12.5C16 12.7761 15.7761 13 15.5 13H2.5C2.22386 13 2 12.7761 2 12.5V11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
